(function () {
  var picker = document.querySelector('[data-language-picker]');
  if (!picker) return;

  var toggle = picker.querySelector('[data-language-toggle]');
  var menu = picker.querySelector('[data-language-menu]');
  var flag = picker.querySelector('[data-language-current-flag]');
  var options = picker.querySelectorAll('[data-language-option]');

  function currentLanguage() {
    var htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    var cookie = document.cookie.match(/(?:^|;\s*)googtrans=\/[^/]+\/([^;]+)/);
    if (htmlLang.indexOf('fr') === 0 || (cookie && cookie[1] === 'fr')) return 'fr';
    if (/^fr\./i.test(location.hostname)) return 'fr';
    return 'en';
  }

  function sync() {
    var language = currentLanguage();
    flag.src = language === 'fr'
      ? 'https://cdn.gtranslate.net/flags/svg/fr.svg'
      : 'https://cdn.gtranslate.net/flags/svg/en-ca.svg';
    toggle.setAttribute('aria-label', language === 'fr' ? 'Choisir la langue' : 'Choose language');
    options.forEach(function (option) {
      option.setAttribute('aria-checked', String(option.dataset.languageOption === language));
    });
  }

  function closeMenu() {
    menu.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', function () {
    menu.hidden = !menu.hidden;
    toggle.setAttribute('aria-expanded', String(!menu.hidden));
    if (!menu.hidden) menu.querySelector('[aria-checked="true"]').focus();
  });

  document.addEventListener('click', function (event) {
    if (!picker.contains(event.target)) closeMenu();
  });
  picker.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMenu();
      toggle.focus();
    }
  });

  function changeLanguage(language) {
    if (language === currentLanguage()) return;

    var officialSelect = document.querySelector('#gtranslate-engine .gt_selector');
    if (officialSelect) {
      officialSelect.value = 'en|' + language;
      officialSelect.dispatchEvent(new Event('change', { bubbles: true }));
      window.setTimeout(sync, 300);
      return;
    }

    if (typeof window.doGTranslate === 'function') {
      window.doGTranslate('en|' + language);
      window.setTimeout(sync, 300);
      return;
    }

    var appLink = document.querySelector('a.glink[data-gt-lang="' + language + '"], #gtranslate-engine a[data-gt-lang="' + language + '"]');
    if (appLink) {
      appLink.click();
      window.setTimeout(sync, 300);
      return;
    }

    // The GTranslate widget reads this cookie on the next page load.
    document.cookie = 'googtrans=/en/' + language + '; path=/; SameSite=Lax';
    location.reload();
  }

  options.forEach(function (option) {
    option.addEventListener('click', function () {
      closeMenu();
      changeLanguage(option.dataset.languageOption);
    });
  });

  // The draft preview does not inject the app widget. Load GTranslate's own
  // selector as the translation engine while keeping its UI visually hidden.
  if (!window.gtranslateSettings && !document.querySelector('script[src*="cdn.gtranslate.net/widgets/"]')) {
    window.gtranslateSettings = {
      default_language: 'en',
      languages: ['en', 'fr'],
      wrapper_selector: '#gtranslate-engine',
      flag_size: 24
    };
    var script = document.createElement('script');
    script.src = 'https://cdn.gtranslate.net/widgets/latest/dropdown.js';
    script.defer = true;
    document.head.appendChild(script);
  }

  sync();
  new MutationObserver(sync).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['lang', 'class']
  });
})();
